module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/hero-desktop-475a954d1304e6f0711b0aed09300fc2.png";